/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import {
  TablePagination,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
} from '@material-ui/core';

import Status from '../../service/translateStatus';

function createData(
  nf,
  nfLink,
  id,
  cpf,
  name,
  proxy,
  nfNd,
  order,
  process,
  conciliation,
  qtd,
  value,
  status,
  all,
) {
  return {
    nf,
    nfLink,
    id,
    name,
    cpf,
    status,
    proxy,
    nfNd,
    order,
    process,
    conciliation,
    qtd,
    value,
    all,
  };
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#005D9F',
    fontFamily: 'Open Sans',
    color: theme.palette.common.white,
  },
  body: {
    color: '#717171',
    fontFamily: 'Open Sans',
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: '#41b490',
      color: '#41b490',
    },
  },
}))(TableRow);

// eslint-disable-next-line no-unused-vars
export default function ReleaseMoneyTableCR({
  docs,
  // setDocs,
  page,
  setPage,
  itens,
  setItens,
  total,
}) {
  const classes = useStyles();
  // const history = useHistory();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const list = [];
    docs.forEach(d => {
      list.push(
        createData(
          d.nf,
          d.nf_link,
          d.id,
          d.cpf,
          d.name,
          d.proxy,
          d.nd,
          d.pedido,
          d.processamento,
          d.conciliacao,
          d.qtd,
          d.valor,
          d.status,
          d,
        ),
      );
    });
    // setDataExcel({ Cartoes: listCard });
    setRows(list);
  }, [docs]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(event.target.value);
  };

  return (
    <>
      <Paper className={classes.root}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Nº do Pedido</StyledTableCell>
                <StyledTableCell>NF</StyledTableCell>
                <StyledTableCell>ND</StyledTableCell>
                <StyledTableCell>Portador</StyledTableCell>
                <StyledTableCell>CPF</StyledTableCell>
                <StyledTableCell>Proxy ou Conta</StyledTableCell>
                <StyledTableCell>Valor</StyledTableCell>
                <StyledTableCell align="right">Status</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <StyledTableRow key={i}>
                  <StyledTableCell>{row.order}</StyledTableCell>
                  <StyledTableCell>{row.nf}</StyledTableCell>
                  <StyledTableCell>{row.nfNd}</StyledTableCell>
                  <StyledTableCell>{row.name}</StyledTableCell>
                  <StyledTableCell style={{ cursor: 'pointer' }}>
                    {row.cpf}
                  </StyledTableCell>
                  <StyledTableCell>{row.proxy}</StyledTableCell>
                  <StyledTableCell>
                    {row.value && `R$${row.value}`}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {Status(row.status)}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
          component="div"
          count={total}
          rowsPerPage={itens}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* MODAL DE EDIÇÃO */}
    </>
  );
}
